import { render, staticRenderFns } from "./icon-account.vue?vue&type=template&id=0e396964"
import script from "./icon-account.vue?vue&type=script&lang=js"
export * from "./icon-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports